import { render, staticRenderFns } from "./AlterarDadosApoio.vue?vue&type=template&id=0170213c&scoped=true"
import script from "./AlterarDadosApoio.vue?vue&type=script&lang=js"
export * from "./AlterarDadosApoio.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosApoio.vue?vue&type=style&index=0&id=0170213c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170213c",
  null
  
)

export default component.exports